export function propsToInitialState(data, coSoCheBienList, loHangList, trangThaiMuaList) {
  const dataInit = { ...data };
  dataInit.ngayMua = data?.ngayMua || null;
  dataInit.soLuong = data?.soLuong || null;
  dataInit.coSoCheBien = coSoCheBienList?.find(x => x?.id === data?.idCoSoCheBien) || null;
  dataInit.loHang = loHangList?.find(x => x?.id === data?.idLoHang) || null;
  dataInit.trangThaiMuaHang = trangThaiMuaList?.find(x => x?.id === data?.trangThaiMua) || null;
  return dataInit;
}

export function parseDataSave(value) {
  const dataSave = { ...value };
  dataSave.ngayMua = value?.ngayMua || 0;
  dataSave.soLuong = value?.soLuong || 0;
  dataSave.idCoSoCheBien = value?.coSoCheBien?.id || 0;
  dataSave.idLoHang = value?.loHang?.id || 0;
  dataSave.trangThaiMua = value?.trangThaiMuaHang?.id || 0;
  return dataSave;
}
